<template>
  <div class="flex flex-row justify-between items-center gap-2 overflow-x-auto">
    <div class="flex flex-row gap-2">
      <div v-for="filter in filters" :key="filter.type + '_' + filter.key">
        <HierarchySelector
          v-if="filter.type === 'hierarchy'"
          allowTenantSelection
          cascade-check
          multiple
          :hierarchy="filter.options"
          :search-placeholder="
            filter.placeholder ?? t('components.inputs.search')
          "
          :label="filter.label ?? t('admin.search.filters.space')"
          :value="filterValue(filter.key)"
          @change="handleFilter(filter, $event)"
          :name="filter.key"
          :id="filter.key"
          class="block w-full rounded-sm border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
        />
        <DateFilter
          v-else-if="filter.type === 'date'"
          @change="handleFilter(filter, $event)"
          :value="filterValue(filter.key)"
          :label="filter.label"
        />
        <DropdownSelector
          v-else-if="filter.type === 'options'"
          @change="handleFilter(filter, $event)"
          :value="filterValue(filter.key)"
          :options="filter.options"
          :label="filter.label"
          multiple
        />
      </div>
    </div>

    <SearchFilter
      :key="'search'"
      @update:modelValue="handleFilter({ key: 'search' }, $event)"
      :modelValue="filterValue('search')"
    />
  </div>
</template>

<script setup>
import HierarchySelector from "@/Tailwind/Components/Input/HierarchySelector.vue";
import SearchFilter from "@/Tailwind/Components/Input/Filters/SearchFilter.vue";
import DateFilter from "@/Tailwind/Components/Input/Filters/DateFilter.vue";
import { useFilters } from "@/Tailwind//Mixins/useFilters";
import DropdownSelector from "@/Tailwind/Components/Input/DropdownSelector.vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  filterStoreKey: {
    type: String,
    required: true,
  },
  filters: {
    type: Array, // Array of objects containing key, label, type, value
    required: true,
  },
});

const { t } = useI18n();

const { filterValue, handleFilterChange } = useFilters(props.filterStoreKey);

const handleFilter = (filter, value) => {
  if (filter.transform) {
    value = filter.transform(value);
  }

  handleFilterChange(filter.key, value);
};
</script>
